import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationsEN from './en/translations.json';

export const resources = {
  en: translationsEN,
} as const;

i18n.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  saveMissing: true,
  missingKeyHandler: (language, namespace, key) =>
    console.error(`Missing translation key: ${key}`),
  resources,
});
